/**
 * Mock Data: Transaction Activity Chart
 * Mock data for monthly transaction activity
 *
 * Corresponds to Postman endpoint: GET /product/api/v1/dashboard/transaction-activity
 */

import type { TransactionActivityApiResponse } from '../data/remote/response';

// Re-export types from response module for backward compatibility
export type {
  TransactionActivityPoint,
  TransactionActivityData,
  TransactionActivityApiResponse,
} from '../data/remote/response';

// Legacy alias for backward compatibility
export type TransactionActivityResponse = TransactionActivityApiResponse;

export const mockTransactionActivityData: TransactionActivityApiResponse = {
  data: {
    year: 2025,
    // Aligned with Postman /product/api/v1/dashboard/transaction-activity sample response
    points: [
      { month: 'Jan', value: 22000 },
      { month: 'Feb', value: 52000 },
      { month: 'Mar', value: 58000 },
      { month: 'Apr', value: 39000 },
      { month: 'May', value: 78000 },
      { month: 'Jun', value: 50000 },
      { month: 'Jul', value: 38000 },
      { month: 'Aug', value: 35000 },
      { month: 'Sep', value: 49000 },
      { month: 'Oct', value: 72000 },
      { month: 'Nov', value: 65000 },
      { month: 'Dec', value: 55000 },
    ],
  },
  meta: {
    code: '20000',
    message: 'ok',
  },
};
